<template>
    <div class="porowsection">
<div class="row">
    <div class="col-lg-12 col-md-12">
        <div class="card panel ">
            <div class="card-header headnbtn">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="card-title mb-0 flex-grow-1">SALES REPORTS</h5>
                    <!--<div class="flex-shrink-0">
                        <a href="#" class="btn btn-primary btn-sm" id="qfilter"><i class="ri-filter-line align-middle me-1"></i> Filter</a>
                    </div>-->
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-responsive product-create ">
                    <table class="table table-nowrap table-bordered align-middle table-custom mb-0">
                        <thead>
                        <tr>
                            <th style="width: 90px">#</th>
                            <th style="width: 180px">Type</th>
                            <th style="width: 150px">Date</th>
                            <th style="width: 160px">Order Number</th>
                            <th >Customer Name</th>
                            <th style="width: 150px">Order Total</th>
                            <!-- <th>Status</th>
                            <th style="width: 120px">Action </th> -->
                        </tr>
                        </thead>
                        <template v-if="customerData.orders.length > 0">
                            <template  v-for="(customer, index) in customerData.orders">
                                <tr :id="customer.id">
                                    <td>{{index + 1}}</td>
                                    <td>Sales Order</td>
                                    <td>{{formatDate(customer.order_date)}}</td>
                                    <td><router-link :to="{name: 'orderShow', params: {id: customer.id}}" target="_blank"
                                        title="Order Details">{{customer.order_number}}</router-link></td>
                                    <template v-if="customer.customer != null">
                                        <td><router-link :to="{name: 'customerDetails', params: {id: customer.customer.id}}" target="_blank"
                                        title="Details Customer">{{customer.customer ? customer.customer.company_name : ""}}</router-link></td>

                                    </template>
                                    <template v-else>
                                        <td>{{customer.customer ? customer.customer.company_name : ""}}</td>
                                    </template>
                                    
                                    <td>${{numberWithCommas(customer.total_amount.toFixed(2))}}</td>
                                    <!-- <td>${{customer.vendor_cost}}</td>
                                    <td><a href="#" :class="[customer.status=='1' ? 'btn active-btn':'btn inactive-btn']" >{{(customer.status=='1')?'Active':'Inactive'}}</a></td>
                                    <td>
                                        <router-link
                                                    :to="{name: 'productsDetails', params: {id: customer.id}}"
                                                    class="btn view-btn" title="Details Product" :data-id="customer.id">
                                                    <i class="ri-eye-line"></i></router-link>
                                        <router-link
                                                    :to="{name: 'editProducts', params: {id: customer.id}}"
                                                    class="edit_btn" title="Edit Product" :data-id="customer.id"><i class="ri-edit-fill me-1"></i></router-link>
                                                   
                                    </td> -->
                                </tr>
                                
                            </template>
                            <tr><td></td><td></td><td></td><td></td><td><strong>Total</strong></td><td><strong>${{numberWithCommas(customerData.total.transaction.toFixed(2))}}</strong></td></tr>
                        </template>
                        <template v-else>
                            <tr><td colspan="8" style="text-align:center;">No records found</td></tr>
                        </template>
                    </table>

                    <!-- <div class="btnrow text-left">
                        <div class="overflow-auto mb-3">
                            <b-pagination
                                v-model="current_page"
                                :total-rows="total"
                                :per-page="per_page"
                            ></b-pagination>
                        </div>
                    </div> -->
                </div>

            </div>

        </div>
    </div>


</div>


    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
export default {
    name: "ProductList",
    props: ['bus','status_filter','customer_filter','order_number','vendor_filter','search_by_date','date_range'],
    created() {
        if(localStorage.getItem('token')){
            console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.setSuccessMessage(null);
        //this.getCustomers();
    },
    mounted() {
        if(this.status_filter) {
            this.filterForm.status_filter = this.status_filter;
            
        }
         if(this.customer_filter) {
            this.filterForm.customer_filter = this.customer_filter;
           
        }
        if(this.order_number) {
            this.filterForm.order_number = this.order_number;
            
        }
         if(this.vendor_filter) {
            this.filterForm.vendor_filter = this.vendor_filter;
            
        }
        if(this.search_by_date) {
            this.filterForm.search_by_date = this.search_by_date;
            
        }
        if(this.date_range) {
            this.filterForm.date_range = this.date_range;
            
        }

        
        
        
        

        this.bus.$on('getCustomers', this.getCustomers)
    },
    data(){
        return {
            selected:[],
            options:[
                // { label: 'Select More Column', id: 0 },
                { label: 'General phone number', id: 1 },
                { label: 'Billing email', id: 2 },
                { label: 'Total number of quotes', id: 3 },
                { label: 'Total number of orders', id: 4 },
            ],
            customerData:{
                orders:[],
                total:{
                    transaction:0
                }
            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: '',
                customer_filter:null,
                order_number:null,
                vendor_filter:null,
                date_range:null,
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        // updatePagination(){
        //     if(this.current_page != 1){
        //         this.getCustomers();
        //     }
        // },
        getCustomers() {

            
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so.getReports',{order_number: this.filterForm.order_number,search_filter:this.filterForm.search_filter,status_filter:this.filterForm.status_filter,customer_filter:this.filterForm.customer_filter,
            vendor_filter:this.filterForm.vendor_filter,search_by_date:this.filterForm.search_by_date,date_range:this.filterForm.date_range
            } ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {

                    //if(data.errors){
                    if (data.errors && Object.keys(data.errors).length) {
                        
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage != null){
                        
                        self.setErrorMessage(data.errorMessage);
                    } else {
                       
                        this.customerData = data.data;
                        this.current_page = data.data.current_page;
                        this.per_page = data.data.per_page;
                        this.total = data.data.total;
                        //this.setCustomers(data.data);
                        console.log("orders  ",data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return index;
        },
        handleFileUpload(){
            this.csv_file = this.$refs.csv_file.files[0];
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        
    },
    watch: {
        current_page: {
            handler: function(value) {
                    //this.getCustomers();
                console.log("watch ",value);
                // this.fetchData().catch(error => {
                // console.error(error)
                // })
            }
        },
        selected: {
            handler: function(selectedVal) {
                //this.getCustomers();
                console.log("watch ",selectedVal);

            }
        },
        customer_filter: {
            handler: function (value) {
                this.filterForm.customer_filter = value;
            }
        },
        status_filter: {
            handler: function (value) {
                this.filterForm.status_filter = value;
            }
        },
        order_number: {
            handler: function (value) {
                this.filterForm.order_number = value;
            }
        },
         vendor_filter: {
            handler: function (value) {
                this.filterForm.vendor_filter = value;
            }
        },
        search_by_date: {
            handler: function (value) {
                this.filterForm.search_by_date = value;
            }
        },
        date_range: {
            handler: function (value) {
                this.filterForm.date_range = value;
            }
        },
        
        
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
.select2-selection {
    border-radius: 0px !important;
    text-align: left !important;
}
.select2-dropdown {
    border-radius: 0px !important;
}
</style>
